"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlanceCoBrowse = GlanceCoBrowse;
function GlanceCoBrowse() {
    var glanceScript = document.createElement('script');
    glanceScript.src = 'https://www.glancecdn.net/cobrowse/CobrowseJS.ashx?group=20085&site=staging';
    glanceScript.dataset.inputevents = '{"ctrl-13":"startSession"}';
    glanceScript.dataset.site = 'staging';
    glanceScript.dataset.groupid = '20085';
    glanceScript.id = 'cobrowsescript';
    glanceScript.text = 'text/javascript';
    document.head.appendChild(glanceScript);
    return null;
}
//# sourceMappingURL=GlanceCobrowse.js.map